import React from 'react';
import { SectionMessageAppearance } from './types';

import SectionMessage from '@atlaskit/section-message';

interface SectionMessageContainerProps {
  appearance: SectionMessageAppearance;
  message: string;
  link_text?: string;
  link?: string;
}

export default function SectionMessageContainer({
  appearance,
  message,
  link_text,
  link,
}: SectionMessageContainerProps) {
  function maybeRenderLink() {
    if (link) {
      return (
        <p>
          <a href={link} target="_blank">
            {link_text}
          </a>
        </p>
      );
    }
  }

  return (
    <SectionMessage appearance={appearance}>
      <p>{message}</p>
      {maybeRenderLink()}
    </SectionMessage>
  );
}
